import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Mail, Phone } from 'lucide-react';

const team = [
  {
    name: 'Jharna Roy',
    role: 'Principal Designer',
    image: '/team/jharna.jpeg',
    bio: 'Leading creative vision with 12+ years in luxury interior design.',
  },
  {
    name: 'Bibek Das',
    role: 'Chief Architect',
    image: '/team/bibek.jpeg',
    bio: 'Specialist in space planning and architectural integration.',
  },
  {
    name: 'Deepak Choudhury',
    role: '3D Visualization Lead',
    image: '/team/deepak.jpeg',
    bio: 'Bringing designs to life through stunning visual experiences.',
  },
    {
    name: 'Shankar Singh',
    role: 'Sites Supervision ',
    image: '/team/shankar.jpeg',
    bio: 'Driving brand visibility and growth through strategic digital marketing, campaign planning, and online audience engagement.',
  },
];

export default function Team() {
  return (
    <section className="py-24 md:py-32 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16 md:mb-20"
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-[1px] bg-[#C9A962]" />
            <span className="text-[#C9A962] tracking-[0.3em] text-xs uppercase">Our Experts</span>
            <div className="w-12 h-[1px] bg-[#C9A962]" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-[#2C2C2C] mb-4">
            Meet Our Team
          </h2>
          <p className="text-[#2C2C2C]/60 max-w-2xl mx-auto text-lg">
            A passionate team of designers, architects, and project managers dedicated to crafting exceptional spaces.
          </p>
        </motion.div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {team.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group"
            >
              {/* Image Container */}
              <div className="relative overflow-hidden mb-6 bg-white">
                <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-80 object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
                  />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#2C2C2C] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                {/* Social Links */}
                <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-3 opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all duration-500">
                  <a
                    href="#"
                    className="w-10 h-10 bg-white/90 backdrop-blur flex items-center justify-center hover:bg-[#C9A962] hover:text-white transition-colors"
                  >
                    <Linkedin className="w-4 h-4" />
                  </a>
                  <a
                    href="#"
                    className="w-10 h-10 bg-white/90 backdrop-blur flex items-center justify-center hover:bg-[#C9A962] hover:text-white transition-colors"
                  >
                    <Mail className="w-4 h-4" />
                  </a>
                  <a
                    href="#"
                    className="w-10 h-10 bg-white/90 backdrop-blur flex items-center justify-center hover:bg-[#C9A962] hover:text-white transition-colors"
                  >
                    <Phone className="w-4 h-4" />
                  </a>
                </div>

                {/* Decorative Corner */}
                <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-[#C9A962] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>

              {/* Info */}
              <div className="text-center">
                <h3 className="font-serif text-xl text-[#2C2C2C] mb-1 group-hover:text-[#C9A962] transition-colors">
                  {member.name}
                </h3>
                <p className="text-[#C9A962] text-sm tracking-wider uppercase mb-3">
                  {member.role}
                </p>
                <p className="text-[#2C2C2C]/60 text-sm leading-relaxed">
                  {member.bio}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}